export default __webpack_public_path__ + "static/pragicts-secops-banner-are-you-sure-a931d0618b3ec6f7717dde913cba9e79.jpg";